import React from 'react';
import ActivosAsegurado from './index';

export default function EquipoElectronico() {
    return (<ActivosAsegurado cClasif={'Equipo Electronico'}  cTitulo ={'Equipo Electronico'}/>);
}
